import { capitalize } from "@mui/material";

const TopUpPlanCard = ({ plan, isCurrentPlan, addTopUp }) => {
  return (
    <div className="plansWrap__list__item" key={plan.id}>
      <div className="card">
        <h2 className="title">{capitalize(plan?.planType ?? "")}</h2>
        <div className="card__info">
          <div className="card__info__item">
            <div className="card__info__flexRow">
              <h3>
                <span className="form__label">Plan Name</span>
                {plan?.name}
              </h3>
              <h3 style={{ textAlign: "right", gap: 0 }}>
                <span className="form__label">Price</span>
                <h5
                  className="price"
                  style={{
                    fontSize: "1.25rem",
                    lineHeight: "30px",
                  }}
                >
                  ${plan?.price} <span>/{plan?.numberOfCredits} Credits</span>
                </h5>
              </h3>
            </div>
          </div>
          <div className="card__info__item">
            {isCurrentPlan ? (
              <button className="btn btn__primary btn--currentPlan" disabled>
                Current Plan
              </button>
            ) : (
              <button
                className="btn btn__primary"
                onClick={() => addTopUp(plan)}
              >
                Add Topup
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopUpPlanCard;
